






import {Component, Vue, Watch} from 'vue-property-decorator';
import {EVENTBUS_TOPICS} from '@/lib/constants';
import {EventBus} from '@/lib/event-bus';
import axios from 'axios';
import UserActionResultSender from '@/components/application/UserActionResultSender';

@Component
export default class LicenseRedirectChecker extends Vue {
  private redirectInterval: number | null = null;
  private redirectCheckFrequency = 5000;
  private isCheckingLicense = false;

  mounted() {
    // Start checking if we're on the license page
    this.startRedirectChecker();
    EventBus.$on(EVENTBUS_TOPICS.WEBSOCKET_CONNECTED, this.handleConnectionChange);
  }

  beforeDestroy() {
    if (this.redirectInterval) {
      clearInterval(this.redirectInterval);
    }
    EventBus.$off(EVENTBUS_TOPICS.WEBSOCKET_CONNECTED, this.handleConnectionChange);
  }

  @Watch('$store.getters.cubiscanConnected')
  onCubiscanConnectionChange(newValue: boolean) {
    if (newValue) {
      this.checkAndRedirect();
    }
  }

  @Watch('$store.getters.isLicensed')
  onLicenseStatusChange(newValue: boolean) {
    if (newValue) {
      this.checkAndRedirect();
    }
  }

  // Handle websocket connection changes
  handleConnectionChange(connected: boolean) {
    if (connected) {
      this.checkAndRedirect();
    }
  }

  startRedirectChecker() {
    this.redirectInterval = window.setInterval(() => {
      this.checkAndRedirect();
    }, this.redirectCheckFrequency);
  }

  // Check if we should re-verify license status
  async checkAndRedirect() {
    const isOnLicensePage = this.$route.path === '/application/license';
    const currentIsLicensed = this.$store.getters.isLicensed;
    const cubiscanConnected = this.$store.getters.cubiscanConnected;
    if (isOnLicensePage && cubiscanConnected && !this.isCheckingLicense) {
      this.isCheckingLicense = true;
      try {
        const isValid = await this.isLicenseValid();
        if (isValid) {
          this.$router.push('/');
        }
      } catch (error) {
      } finally {
        this.isCheckingLicense = false;
      }
    }
  }

  async isLicenseValid(): Promise<boolean> {
    try {
      const response = await axios.get('/frontend-api/license/check');
      const isLicensed = response.data;
      if (isLicensed !== this.$store.getters.isLicensed) {
        this.$store.dispatch("updateLicenseStatus", isLicensed);
      }
      localStorage.setItem('isLicensed', String(isLicensed));
      return isLicensed;
    } catch (error) {
      UserActionResultSender.showErrorFeedback(error.response.data.responseCode);
      return false;
    }
  }
}
